// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"4e101334","184":"e79244d7","190":"82436d43","379":"cf4cd08b","404":"12443eb5","482":"cb130ec3","825":"f2348fca"}[chunkId] + ".chunk.js";
};